import React, { useState, useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import ApprovalStatus from '../Modals/ApprovalStatus';
import { Modal } from '@mui/material';
import CasesAPI from 'api/CasesAPI';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { handleUpdateTicketNotification } from 'utils/NotificationsFuncs';
import StreamDisplay from 'components/TradeHelper/StreamDisplay';
import { classificationTicketPDF } from 'components/Common/PDFManage';

interface IClassResultsProps {
  cur_user: any;
  cur_case: any;
  trigger: boolean;
  setTrigger: any;
  triggerCSV: boolean;
  setTriggerCSV: any;
}

const ClassResultsComponent: React.FC<IClassResultsProps> = ({ cur_user, cur_case, trigger, setTrigger, triggerCSV, setTriggerCSV }) => {
  const history = useHistory();

  const componentRef = useRef<HTMLDivElement>(null);

  if (!cur_case) {
    history.push('/bite-monitor');
    return <></>;
  }
  const [ isApprovalModalOpen, setIsApprovalModalOpen ] = useState(false);
  const [ responses, setResponses ] = useState<Record<string, string>>({});

  const { enqueueSnackbar } = useSnackbar();

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  const handleApprovalCloseModal = () => {
    setIsApprovalModalOpen(false);
  };

  const changeStatus = async(newStatus: string) => {
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: `changed the status of the ticket from ${cur_case.data.status} to ${newStatus}`,
      timeStamp: Date.now()
    };
    const update: any = {
      _id: cur_case.data._id,
      status: newStatus,
      activity: [ ...cur_case.data.activity, actObj ]
    };
    const res = await CasesAPI.updateCase(update);
    if (res?.success) {
      if (cur_case.data.sharedWith.length > 0 && cur_user.basics.Id === cur_case.data.createdBy) {
        cur_case.data.sharedWith.forEach(async(user: string) => {
          handleUpdateTicketNotification(cur_case.data.ticketName, cur_user, user, cur_case.data._id);
        });
      } else if (cur_case.data.sharedWith.length > 0 && cur_user.basics.Id !== cur_case.data.createdBy) {
        const shareArr = cur_case.data.sharedWith.filter((user: string) => {
          return user !== cur_user.basics.id && user !== cur_user.basics.email;
        });
        shareArr.push(cur_case.data.createdBy);
        shareArr.forEach(async(user: string) => {
          handleUpdateTicketNotification(cur_case.data.ticketName, cur_user, user, cur_case.data._id);
        });
      }
    } else {
      enqueueSnackbar('There was an error updating the status of your ticket', { variant: 'error' });
    }
    setTrigger(!trigger);
  };

  const handleCSV = () => {
    classificationTicketPDF(componentRef, `${cur_case.data.ticketName}.pdf`);
    setTriggerCSV(false);
  };

  useEffect(() => {
    const initialResponses = cur_case.data.followUps.reduce((acc: any, item: any) => {
      acc[item.question] = item.answer || '';
      return acc;
    }, {} as Record<string, string>);
    setResponses(initialResponses);
  }, []);

  useEffect(() => {
    if (triggerCSV) {
      handleCSV();
    }
  }, [ triggerCSV ]);

  return (
    <>
      <div className='results-card-frame'>
        <div className='results-card-frame-comp'>
          <div className='results-card-frame-head'>
        Last Screen
          </div>
          <div className='results-card-frame-body'>
            N/A
          </div>
          <div className='results-card-frame-footer'>
          </div>
        </div>
        <div className='results-card-frame-comp'>
          <div className='results-card-frame-head'>
          Screening Frequency
          </div>
          <div className='results-card-frame-body'>
            N/A
          </div>
          <div className='results-card-frame-footer'>
          </div>
        </div>
        <div className='results-card-frame-comp'>
          <div className='results-card-frame-head'>
          Status
          </div>
          <div className='results-card-frame-body'>
            <svg xmlns='http://www.w3.org/2000/svg' width='9' height='8' viewBox='0 0 9 8' fill='none' style={{ marginRight: '5px' }}>
              <circle cx='4.5' cy='4' r='3' fill={cur_case.data.status === 'Complete' ? '#BDBEC1' : cur_case.data.status === 'Pending' ? '#FDB022' : cur_case.data.status === 'New Results' ? '#4895EF' : cur_case.data.status === 'Approved' ? '#47CD89' : cur_case.data.status === 'Rejected' ? '#F04438' : '#B67DFF' }/>
            </svg>
            {cur_case.data.status}
          </div>
          <div className='results-card-frame-footer' onClick={() => setIsApprovalModalOpen(true)}>
          Change
          </div>
        </div>
        <div className='results-card-frame-comp'>
          <div className='results-card-frame-head'>
          Ticket Type
          </div>
          <div className='results-card-frame-body-doc'>
            <div className='results-card-frame-body-texts'>
              {cur_case.data.docType}
            </div>
          </div>
          <div className='results-card-frame-footer' style={{ height: '18px' }}>
            {' '}
          </div>
        </div>
      </div>

      <div className='results-frame' ref={componentRef}>
        <div className='class-ticket-container'>
          <div className='class-ticket-left-div'>
            <div className='class-ticket-searched-val'>
              <h1>Classification Description:</h1>
              <h2>{cur_case.data.classificationValue}</h2>
            </div>
            <div className='class-ticket-results'>
              <h1>Results:</h1>
              <h2>Product Description: {cur_case.data.commodity.commodityName}</h2>
              <h2>HTS Code: {cur_case.data.commodity.harmonizedScheduleCode}</h2>
            </div>
            <h1>Clarifying Questions:</h1>
            <div className='classify-body-ticket'>
              {cur_case.data.followUps.length > 0 ?
                cur_case.data.followUps.map(({ question }: any, index: number) => (
                  <div key={index} style={{ width: '95%' }}>
                    <div className='classify-header-ticket'>
                      {question}
                    </div>
                    <div className='classify-cont'>
                      <div className='classify-cont-sec'>
                        <div className='classify-cont-sec-div'>
                          <input
                            placeholder='Enter details'
                            className='classify-cont-sec-input'
                            type='text'
                            disabled
                            value={responses[question] || ''}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )) : <h3>None</h3>}
            </div>
          </div>
          <div style={{ width: '70%' }}>
            <div className='classify-results-card-list'>
              <StreamDisplay
                streamData={cur_case.data.aiStream}
                ticket={true}
              />
            </div>
          </div>

        </div>


      </div>
      <Modal
        open={isApprovalModalOpen}
        onClose={handleApprovalCloseModal}
      >
        <ApprovalStatus
          handleClose={handleApprovalCloseModal}
          changeStatus={changeStatus}
          curStatus={cur_case.data.status}
        />
      </Modal>
    </>
  );
};

export default ClassResultsComponent;
